import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import SectionHeading from '../SectionHeading/SectionHeading';
import DashboardConstants from '../myaccount/DashboardConstants';
import ChangeService from '../../services/ChangeService';

const OhNoMessage = (props) => {
  if (props.isAddressSelected && !ChangeService.canMove(props)) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-9">
            <SectionHeading
              title={'Oh No!'}
              titleClassName={'address-search-section-title'}
              numberClassName={'address-search-heading-number'}
              description={DashboardConstants.NOT_AVAILABLE_DESCRIPTION}
            >
              <Link to={'/contact-us'} target="_blank">Get in touch</Link> with us to let us know
              you&apos;ll need to disconnect so we can get it sorted for you.
            </SectionHeading>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

OhNoMessage.propTypes = {
  isAddressSelected: PropTypes.bool.isRequired
};

export default OhNoMessage;



/** WEBPACK FOOTER **
 ** ./src/components/Change/OhNoMessage.js
 **/